module.exports = __webpack_public_path__ + "img/onboarding-icon-2.a54c25c7.svg";